<script>
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import { getStandardUnits, getDimensionalUnits } from '@/utils/units'
import { byDocumentType } from '@/utils/document-setting';
import { documentTemplates } from '@/utils/document-template';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';
import DocumentPlaceholder from '@/components/common/quotation-placeholder.vue';
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore';
import { useUnitsStore } from '@/stores/useUnitsStore'

export default {
  components: {
   DocumentPlaceholder 
  },
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      gst_no: '',
      modal_title: '',
      subject: '',
      to_name: '',
      to_email: '',
      to_phone: '',
      to_address: '',
      to_city: '',
      to_pincode: '',
      to_state: null,
      to_country: null,
      selectedParty: null,
      status: null,
      tax_mode: null,
      selectedTax: null,
      selectedUnit: null,
      quotation_date: '',
      valid_until: '',
      type: "quotation",
      sales_person_id: null,
      expected_closure_date: '',
      closure_probability: '',
      summary: '',
      notes: '',
      statuses: ['Draft', 'Sent', 'Accepted', 'Rejected'],
      tax_modes: ['Item', 'Invoice'],
      place_of_supply: '',
      countries: [],
      taxes: [],
      parties: [],
      allItems: [],
      items: [
        { item: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }
      ],
      transportation_cost: 0,
      installation_cost: 0,
      discount: 0,
      states: [],
      loading: false,
      editorConfig: {
      height: 120,  // Fixed height prevents resize loops
      toolbar: {
        items: ['bold', 'italic']
      },
      // 🔧 RESIZEOBSERVER FIX
      resize_enabled: false, 
      resize_image: {
        resizeOptions: [
          { name: 'resize-original', label: 'Original', value: null }
        ]
      }
    },
      editor: ClassicEditor,
      action: '',
      acceptance_name: '',
      acceptance_email: '',
      currency: '',
      mass_delete: false,
      party_type: '',
      activities: [],
      remark: '',
      users: [],
      user_id: null,
      units: [],
      standardUnits: [],
      dimensionalUnits: [],
      assignment_history: [],
      errors: {},
      previewData: null,
      settings:{
       terms: '', 
       mail_subject: "Quotation from {entity_name}",
       mail_body: "Dear {client_name}, <br> Please find the details of the quotation {quotation_subject} below. Explore the quotation and accept if you find it perfect for you.",
       mail_footer: "<b>Questions about the Quotation?</b> <br>If you need to modify the quotation or have questions about the details in the quotation, please reach out to the sender by emailing them directly.<b> <br><br>Do Not Share This Email</b> <br>This email contains a secure link to your quotation. Please do not share this email, link, or access code with others. <br><br>Thank You, <br>{sender_name}, <br>M:{sender_mobile}", 
       send_on_email: false,
      },
      templates: [],
      template: null,
      document_template_id: null,
      should_send_mail: false,
    };
  },

  computed: {
   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
    if(this.tax_mode === 'Invoice'){
     const tax_rate = this.selectedTax?.rate || 0;
     const taxable_amount = this.totalAmount - this.discount;
     return (taxable_amount * tax_rate) / 100;
    }else{
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
    }
   },

   grandTotal(){
    const discountAmount = parseFloat(this.discount) || 0;
    const installationAmount = parseFloat(this.installation_cost) || 0;
    const transaportationAmount = parseFloat(this.transportation_cost) || 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount + transaportationAmount + installationAmount;
   },

   showTaxInfo(){
    return !(this.tax_mode === 'Item' && this.clientSetting?.tax_type === 'inclusive');
   },

  },

//   mounted(){ 
//    this.getCountries();
//    this.fetchUnits();
// },

  watch:{
   
   discount(newVal){
    if (this.totalAmount === 0 || !this.totalAmount) return;
    if(newVal < 0){
     this.discount = 0;
     this.$swalToast("Discount cannot be negative", 'warning');
    }else if(newVal > this.totalAmount){
     this.discount = this.totalAmount;
     this.$swalToast("Discount cannot exceed total amount", 'warning');
    }
   },

   party_type(newVal, oldVal){
    if(newVal !== oldVal && !this.id){
     // Clear selected party and party_id if type changed
      this.selectedParty = null;
     // If you store party_id separately:
      this.party_id = null;
     // Also clear parties array if you want
      this.parties = [];
    }
   },

  },

 methods: {
getItemGeneralError(index){
  const key = `items.${index}`;
  return this.errors[key] ? this.errors[key] : null;
},

// async fetchUnits(){
//   try{
//     const [standard, dimensional] = await Promise.all([
//       getStandardUnits(),
//       getDimensionalUnits()
//     ]);
//     this.standardUnits = standard;
//     this.dimensionalUnits = dimensional;
//   }catch(error){
//     this.$swalToast(error.message, 'error');
//   }
// },

async fetchUnits(){
  const store = useUnitsStore()
  const { standard, dimensional } = await store.loadUnits()
  this.standardUnits = standard
  this.dimensionalUnits = dimensional
},

  add(){
   this.resetForm();
  this.getCountries(); 
  this.fetchUnits(); 
   this.getTaxes();
   this.getUsers();
   this.getAllItems();
   this.tax_mode = 'Item';
   this.byType(this.type);
   this.allDocumentTemplates();
   this.quotation_date = this.$currentDate();
   this.valid_until = this.$currentDate(7);
   this.expected_closure_date = this.$currentDate(7);
   this.summary = this.clientAdmin?.company?.summary || '';
   this.party_type = `App\\Models\\Lead`;
  }, 

  setDefaultSalesPerson(){
   const meInUsers = this.users.find(u => u.id === this.auth?.id);
   if(meInUsers){
    this.sales_person_id = meInUsers.id;
   }
  },

  async getUsers(){
   try{
    const response = await allUsers();
    this.users = response.data.data;
    if(!this.id){
     this.setDefaultSalesPerson(); 
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async allDocumentTemplates(){
    try{
    const response = await documentTemplates(this.type);
    this.templates = response.data.data;
    if(this.id){
     this.template = this.templates.find(t => t.id === this.document_template_id) || null;
    }else{
     // CREATE MODE: Use default document_template_id or first template
     const defaultTemplate = this.templates.find(t => t.id === this.document_template_id) || 
                             (this.templates.length > 0 ? this.templates[0] : null);
     this.template = defaultTemplate;
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    const data = response.data.data;
    this.settings = {
     mail_subject: data?.mail_subject || '',
     mail_body: data?.mail_body || '',
     mail_footer: data?.mail_footer || '',
     terms: data?.terms || '',
     send_on_email: data?.send_on_email || false,
    };
    this.document_template_id = data?.document_template_id;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  // async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/countries');
  //   this.countries = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },

  async getCountries(){
  const store = useCountryStore()
  this.countries = await store.loadCountries()
},

  async editQuotation(quotation_public_token){
   try{
    this.setLoading(true);
    this.getCountries(); 
    this.fetchUnits(); 
    this.getTaxes();
    this.getUsers();
    this.byType(this.type);
    this.allDocumentTemplates();
    await this.getAllItems(); 

    const response = await axios.get(`/quotations/${quotation_public_token}`);
    const data = response.data.data;

    this.document_template_id = data.document_template_id;

    await this.getPartyById(data.party_type, data.party_id);

    this.id = data.id;
    this.gst_no = data.gst_no;
    this.party_type = data.party_type;
    this.subject = data.subject;
    this.to_name = data.to_name;
    this.to_email = data.to_email;
    this.to_phone = data.to_phone;
    this.to_address = data.to_address;
    this.to_city = data.to_city;
    this.to_pincode = data.to_pincode;
    this.to_country = (data.to_country != '') ? this.countries.find(c => c.name === data.to_country) : null;
    if(this.to_country?.id) await this.onCountrySelect(this.to_country);
    this.to_state = (data.to_state != '') ? this.states.find(s => s.name === data.to_state) : null;
    this.tax_mode = data.tax_mode;
    this.quotation_date = data.quotation_date;
    this.valid_until = data.valid_until;
    this.expected_closure_date = data.expected_closure_date;
    this.closure_probability = data.closure_probability;
    this.place_of_supply = data.place_of_supply;
    this.summary = data.summary || '';
    this.settings.terms = data.terms || '';
    this.notes = data.notes || '';
    this.selectedTax = this.taxes.find(t => t.id === data.tax_id) || null;
    this.discount = parseFloat(data.discount || 0);
    this.transportation_cost = parseFloat(data.transportation_cost || 0);
    this.installation_cost = parseFloat(data.installation_cost || 0);
    this.sales_person_id = data.sales_person_id || null;
    

    await this.allDocumentTemplates();

    // Populate items
    this.items = data.quotation_items.map(row => {
     const selectedItem = this.allItems.find(i => i.id === row.item_id);
     const unitPrice = parseFloat(row.unit_price || row.price || 0);
     const qty = parseFloat(row.quantity || 1);
     const selectedTax = row.tax_id ? this.taxes.find(t => t.id === row.tax_id) : null;
     const calcType = selectedItem?.calculation_type || 'standard';
     const availableUnits = calcType === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
     const selectedUnit = row.unit ? availableUnits.find(u => u.value === row.unit) : null;

      const item = {
       item: selectedItem || { id: row.item_id, name: row.name },
       selectedTax: selectedTax,
       selectedUnit: selectedUnit,
       description: row.description || '',
       unit: row.unit || '',
       hsn_code: row.hsn_code || '',
       price: unitPrice,
       originalPrice: unitPrice,
       qty: qty,
       amount: 0,
       calculation_type: calcType,
       width: parseFloat(row.width || 0),
       height: parseFloat(row.height || 0),
       base_unit: selectedItem?.unit || '',
       availableUnits: availableUnits,
       size: 0,
       conversion_factor: 0,
       conversion_rate: 0,
       rmt_width_multiplier: selectedItem?.rmt_width_multiplier || parseFloat(row.rmt_width_multiplier || 1),
      rmt_height_multiplier: selectedItem?.rmt_height_multiplier || parseFloat(row.rmt_height_multiplier || 1),
      };
      return item;
    });

    // Recalculate amounts after all items are set
    this.items.forEach((_, index) => {
      this.updateAmount(index);
    });

   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async getPartyById(party_type, id){
   try{
    let res;
    if(party_type === `App\\Models\\Lead`){
     res = await axios.get(`/leads/${id}`);
    }else{
     res = await axios.get(`/customers/${id}`);
    }
    this.selectedParty = res.data.data;
    this.onPartySelected(this.selectedParty);
   }catch(err){
    this.$swalToast("Party not found", 'error');
   }
  },

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown');
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
addItemRow(){
    this.items.push({ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0, calculation_type: 'standard', width: 0, height: 0, base_unit: '', availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1 });
},
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

   onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
     row.item = null;
     row.selectedTax = null;
     row.selectedUnit = null;
     row.description = '';
     row.unit = '';
     row.hsn_code = '';
     row.price = 0;
     row.qty = 1;
     row.amount = 0;
     return;
    }
  
    // Preserve the tax_id from the items table
    row.description = selectedItem.description || '';
    row.unit = selectedItem.unit || '';
    row.hsn_code = selectedItem.hsn_code || '';
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;
  
    // Set the tax for this item if it exists
    if(selectedItem.tax_id){
     row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
     row.item.tax = row.selectedTax;
    }else{
     row.selectedTax = null;
     row.item.tax = null;
    }

    // Set the unit for this item if it exists (for simple array format)
    // Set calculation type from item
    row.calculation_type = selectedItem.calculation_type || 'standard';
    row.width = 0;
    row.height = 0;

    // Set units based on calculation type
    if(row.calculation_type === 'dimensional'){
     row.availableUnits = this.dimensionalUnits;
     // Set default unit from item's base unit
     if(selectedItem.unit){
      row.selectedUnit = this.dimensionalUnits.find(u => u.value === selectedItem.unit) || null;
      row.unit = selectedItem.unit;
      row.base_unit = selectedItem.unit;
      row.rmt_width_multiplier = selectedItem.rmt_width_multiplier || 1;
      row.rmt_height_multiplier = selectedItem.rmt_height_multiplier || 1;
     }else{
      row.selectedUnit = null;
      row.base_unit = '';
     }
    }else{
     row.availableUnits = this.standardUnits;
     if(selectedItem.unit){
      row.selectedUnit = this.standardUnits.find(u => u.value === selectedItem.unit) || null;
      row.unit = selectedItem.unit;
     }else{
      row.selectedUnit = null;
     }
    }

    row.originalPrice = parseFloat(selectedItem.price || 0);
    this.updateAmount(index);
   },

updateAmount(index){
  const row = this.items[index];
  row.qty = Math.max(1, parseFloat(row.qty) || 1);
  const price = parseFloat(row.price) || 0;

  // Dimensional calculation
if(row.calculation_type === 'dimensional'){
    const width = parseFloat(row.width) || 0;
    const height = parseFloat(row.height) || 0;
    const qty = row.qty;

    const base_unit = row.base_unit || '';
    const selected_unit = row.unit || base_unit;

    // Rmt calculation
    if(selected_unit === 'Rmt'){
        const rmt_w = parseFloat(row.rmt_width_multiplier) || 1;
        const rmt_h = parseFloat(row.rmt_height_multiplier) || 1;
        const size = (((width / 1000) * rmt_w) + ((height / 1000) * rmt_h)) * qty;

        row.size = size;
        row.conversion_factor = 1;
        row.conversion_rate = price;
        row.amount = parseFloat((price * size).toFixed(2));
    } else {
        // Existing area calculation
        const base_factor = this.getUnitFactor(base_unit);
        const selected_factor = this.getUnitFactor(selected_unit);

        const size_in_sqmtr = (width / 1000) * (height / 1000) * qty;
        const size = size_in_sqmtr * selected_factor;

        const conversion_factor = selected_factor / base_factor;
        const conversion_rate = price / conversion_factor;

        row.size = size;
        row.conversion_factor = conversion_factor;
        row.conversion_rate = conversion_rate;
        row.amount = parseFloat((conversion_rate * size).toFixed(2));
    }
} else {
    row.amount = row.qty * price;
}
},

getUnitFactor(unitValue){
  const unit = this.dimensionalUnits.find(u => u.value === unitValue);
  return unit?.factor || 1;
},

  //  async onCountrySelect(country){
  //   this.to_state = null;
  //   this.states = [];
  //    if(country?.id){
  //     try{
  //      const response = await axios.get(`/states/${country.id}`);
  //      this.states = response.data.data;
  //     }catch(error){
  //      this.$swalToast(error.message, 'error');
  //     }
  //    }
  //   },

  async onCountrySelect(country){
  this.to_state = null;
  this.states = [];
  if(country?.id){
    const store = useStatesStore()
    this.states = await store.loadStates(country.id)
  }
},

    async onSearch(search){
     if(!search || search.length < 2) return;
     this.loading = true;
     try{
      let res;
      if(this.party_type === "App\\Models\\Lead"){
       res = await axios.get('/leads/dropdown', { params: { search_keyword: search } });
      }else if(this.party_type === "App\\Models\\Customer") {
       res = await axios.get('/customers/dropdown', { params: { search_keyword: search } });
      }
      this.parties = res.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false;
     }
    },

    async onPartySelected(row){
     this.gst_no = row?.gst_no || ''; 
     this.to_email = row?.email || '';
     this.to_phone = row?.mobile || '';
     this.to_name = row?.company_name || row?.name;
     this.to_address = row?.address || '';
     this.to_city = row?.city || '';
     this.to_pincode = row?.pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.to_country = this.countries.find(c => c.name === row?.country)
      await this.onCountrySelect(this.to_country);
     }
     this.to_state = (row?.state != '') ? this.states.find(s => s.name === row?.state) : null;
     this.currency = row?.currency?.code || '';
    },

    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async submitQuotation(shouldDownload = false) {
     this.setLoading(true);
     this.errors = {};
      try{
       const payload = {
        party_type: this.party_type,
        party_id: this.selectedParty?.id,
        subject: this.subject,
        gst_no: this.gst_no,
        to_name: this.to_name,
        to_email: this.to_email,
        to_phone: this.to_phone,
        to_address: this.to_address,
        to_city: this.to_city,
        to_pincode: this.to_pincode,
        to_state: this.to_state?.name,
        to_country: this.to_country?.name,
        place_of_supply: this.place_of_supply, 
        quotation_date: this.quotation_date,
        valid_until: this.valid_until,
        sales_person_id: this.sales_person_id || null,
        document_template_id: this.template?.id || null,
        expected_closure_date: this.expected_closure_date,
        closure_probability: this.closure_probability,
        summary: this.summary,
        terms: this.settings.terms,
        notes: this.notes,
        tax_mode: this.tax_mode,
        tax_id: this.selectedTax?.id || null,
        discount: this.discount,
        transportation_cost: this.transportation_cost,
        installation_cost: this.installation_cost,
        items: this.items.map(row => ({
         item_id: row.item?.id || null,
         name: row.item?.name,
         description: row.description,
         unit: row.unit,
         hsn_code: row.hsn_code === 'null' || row.hsn_code === '' || row.hsn_code == null ? null : row.hsn_code,
         quantity: row.qty,
         unit_price: row.price,
         tax_id: row.selectedTax?.id || null,
         width: row.calculation_type === 'dimensional' ? row.width : null,
         height: row.calculation_type === 'dimensional' ? row.height : null,
         rmt_width_multiplier: row.unit === 'Rmt' ? row.rmt_width_multiplier : null,
         rmt_height_multiplier: row.unit === 'Rmt' ? row.rmt_height_multiplier : null,
        }))
       };

       let response;
       if(this.id){
        response = await axios.put(`/quotations/${this.id}/update`, payload);
       }else{
        response = await axios.post('/quotations/create', payload);
       }

       this.$swalToast(response.data.message);
       this.$emit('updated');

      // SAVE AND DOWNLOAD TRIGGER 
       if(shouldDownload){
        const quotationId = this.id || response.data.data?.id;
        if(quotationId){
         await downloadPDFUtil('quotations', quotationId);
        }
       }

       this.$closeModal('quotation_modal');
       this.resetForm();

      // SAVE AND SEND TRIGGER
       if(this.should_send_mail){
        const quotation = response.data.data;
        this.$openModal('quotation_mail_modal');
        this.mailQuotation(quotation);
       } 

      }catch(error){
       if(error?.type === 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async deleteQuotation(){
     this.errors = {};
     this.setLoading(true); 
     try{
      const response = await axios.delete(`/quotations/${this.id}/delete`);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('quotation_delete_modal');
     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     if(this.tax_mode === 'Item'){
      if(this.clientSetting?.tax_type === 'inclusive'){
       return item.amount;
      }else{
       if(item.item?.tax){
        return item.amount * (1 + (item.item.tax.rate / 100));
       }
       return item.amount;
      }
     }
     return item.amount;
    },

    quotationAction(quotation_id, action){
     this.id = quotation_id; 
     this.action = action;
    },

    async submitAction(){
     this.errors = {}; 
     this.setLoading(true);
     try{
      const response = await axios.post('quotations/action', {
       id: this.id,
       status: this.action,
       acceptance_name: this.acceptance_name,
       acceptance_email: this.acceptance_email 
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('quotation_action');
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    bulkAction(ids){
     this.ids = ids;
    },

    async submitBulkAction() {
     const result = await this.$confirm({});
     if(result.isConfirmed){
      this.setLoading(true); 
     try{
      const response = await axios.post('/quotations/bulk-actions', {
       ids: this.ids,
       mass_delete: this.mass_delete,
       status: this.status || '',
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('bulk_action_quotation');
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
     }
    },

    async activity(id){
     this.setLoading(true);
     try{
      const response = await axios.get(`/quotations/${id}/activity`);
      this.activities = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async getAllUsers(){
     try{
     const response = await axios.get('/users/all-users');
     this.users = response.data.data; 
     }catch(error){
      console.log(error.message);
     } 
    },

    async assignHistory(id, quotation_number){
     this.id = id;
     this.modal_title = quotation_number;
     await this.getAllUsers();
     this.setLoading(true);
     try{
      const response = await axios.get(`/quotations/${id}/assignment/history`);
      this.assignment_history = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async assignQuotation(){
     this.errors = {};
     this.setLoading(true);
     try{
      const payload = {
       user_id: this.user_id,
       remark: this.remark 
      };
      const response = await axios.patch(`/quotations/${this.id}/assign`, payload);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('quotation_assign_modal');
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     } 
    },

    createViaParty(party_type, party_id){
     this.add(); 
     this.party_type = party_type;
     this.getPartyById(party_type,party_id);
    },

    preview() {
     this.previewData = {
     gst_no: this.gst_no, 
     subject: this.subject,
     to_name: this.to_name,
     to_email: this.to_email,
     to_phone: this.to_phone,
     to_address: this.to_address,
     to_city: this.to_city,
     to_pincode: this.to_pincode,
     to_state: this.to_state?.name,
     to_country: this.to_country?.name,
     quotation_date: this.quotation_date,
     valid_until: this.valid_until,
     expected_closure_date: this.expected_closure_date,
     closure_probability: this.closure_probability,
     place_of_supply: this.place_of_supply,
     summary: this.summary,
     terms: this.settings.terms,
     notes: this.notes,
     tax_mode: this.tax_mode,
     tax_name: this.selectedTax?.name || null,
     selectedTax: this.selectedTax,
     discount: this.discount,
     transportation_cost: this.transportation_cost,
     installation_cost: this.installation_cost,
     items: this.items.map(item => {
      const baseItem = {
        name: item.item?.name || '',
        description: item.description,
        unit: item.unit,
        hsn_code: item.hsn_code,
        price: item.price,
        qty: item.qty,
        amount: item.amount,
        totalWithTax: item.amount,
        image: item.item?.image || null
      };

      // Add tax calculations if tax_mode is 'Item'
      if(this.tax_mode === 'Item'){
       const taxRate = item.item?.tax?.rate || 0;
       const itemTaxAmount = item.amount * (taxRate / 100); 
       return {
          ...baseItem,
          taxRate: taxRate,
          taxAmount: itemTaxAmount,
          taxName: item.item?.tax?.name || '',
          totalWithTax: item.amount + itemTaxAmount
       };
      }
     return baseItem;
    }),
    totalAmount: this.totalAmount,
    taxAmount: this.taxAmount,
    grandTotal: this.grandTotal,
    currency: this.currency
  };

  // Generate unique ID for this preview
  const previewId = Date.now().toString();
  
  // Store data in sessionStorage
  sessionStorage.setItem(`preview_${previewId}`, JSON.stringify(this.previewData));
  
  // Open in new tab with the preview ID
  const url = this.$router.resolve({
    name: 'preview-quotation',
    params: { id: previewId }
  }).href;
   window.open(url, '_blank');
  },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
  
    // Update the item's tax reference for calculations
    if (selectedTax) {
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    } else {
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },
   
onItemUnitSelected(index, selectedUnit){
    const row = this.items[index];
    row.selectedUnit = selectedUnit;  
    if(selectedUnit){
     row.unit = selectedUnit.value;
    }else{
     row.unit = '';
    }
    this.updateAmount(index);
},
   async save(){
    await this.submitQuotation(false);
   },

   async saveAndDownload(){
    await this.submitQuotation(true); 
   },

   async saveAndSend(){
    this.should_send_mail = true;
    await this.submitQuotation(false);
   },

// ##############################
//  *** MAIL FUNCTIONS START ***
// ##############################

    async mailQuotation(row){ 
     this.id = row.id; 
     this.modal_title = row.quotation_number;
     this.to_email = row.to_email;
     await this.byType(this.type);
    },

    async sendMail(){
     this.errors = {};
     this.setLoading(true);
     try{
      const payload = {
       to_email: this.to_email,
       mail_subject: this.settings.mail_subject,
       mail_body: this.settings.mail_body,
       mail_footer: this.settings.mail_footer
      };
      const response = await axios.post(`/quotations/${this.id}/email`, payload);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('quotation_mail_modal');
      this.resetForm();
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     } 
    },

// ##############################
//  *** MAIL FUNCTIONS END ***
// ##############################

    resetForm() {
     this.id = null;
     this.gst_no = '';
     this.subject = '';
     this.to_name = '';
     this.to_email = '';
     this.to_phone = '';
     this.to_address = '';
     this.to_city = '';
     this.to_pincode = '';
     this.to_state = null;
     this.to_country = null;
     this.quotation_date = '';
     this.valid_until = '';
     this.sales_person_id = null;
     this.expected_closure_date = '';
     this.closure_probability = '';
     this.summary = '';
     this.settings.terms = '';
     this.notes = '';
     this.party_type = '';
     this.selectedParty = null;
     this.status = null;
     this.tax_mode = null;
     this.selectedTax = null;
     this.email = '';
     this.mobile = '';
     this.address = '';
     this.city = '';
     this.pincode = '';
     this.place_of_supply = '';
     this.items = [{ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0, calculation_type: 'standard', width: 0, height: 0, base_unit: '', availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0 }];
     this.discount = 0;
     this.transportation_cost = 0;
     this.installation_cost = 0;
     this.errors = {};
    }
  }
};
</script>


<style scoped>
/* ─────────────────────────────────────────────
   QUOTATION MODAL — REDESIGNED UI STYLES
───────────────────────────────────────────── */
 
 
 
/* Main area */
.qm-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
 
/* Topbar */
.qm-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.qm-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.qm-page-sub { font-size: 11px; color: #94a3b8; }
.qm-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #ef4444;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;  font-size: 13px; transition: all .15s;
  color: #ef4444; 
}
.qm-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
 
/* Scrollable body */
.qm-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.qm-body::-webkit-scrollbar { width: 4px; }
.qm-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
 
/* Section cards */
.qm-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px; overflow: visible;
}
.qm-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
}
.qm-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.qm-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.qm-card-body { padding: 14px 16px; }
 
/* Form controls */
.qm-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.qm-label .req { color: #f43f5e; margin-left: 2px; }
.qm-input, .qm-select, .qm-textarea {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.qm-input, .qm-select { height: 35px; }
.qm-textarea { padding: 8px 11px; resize: vertical; }
.qm-input:focus, .qm-select:focus, .qm-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.qm-input.err { border-color: #f43f5e; box-shadow: 0 0 0 3px rgba(244,63,94,.1); }
.qm-select {
  appearance: none;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394a3b8' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 10px center;
}
.qm-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
 
/* Item row */
.qm-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.qm-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.qm-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #3b82f6; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.qm-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.qm-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
 
/* Add item button */
.qm-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s;
}
.qm-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
 
/* Pricing summary */
.qm-price-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 7px 0; border-bottom: 1px dashed #f1f5f9;
}
.qm-price-row:last-of-type { border-bottom: none; }
.qm-price-label { font-size: 12px; color: #64748b; font-weight: 500; }
.qm-price-val { font-size: 12.5px; font-weight: 700; color: #1e293b; }
.qm-price-input-box {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 7px;
  overflow: hidden; width: 126px; background: #fff;
}
.qm-price-prefix {
  padding: 0 7px; font-size: 10px; font-weight: 600;
  color: #94a3b8; background: #f8fafc;
  border-right: 1.5px solid #e2e8f0;
  height: 30px; display: flex; align-items: center;
}
.qm-price-num-input {
  border: none; outline: none; width: 100%;
  text-align: right; font-size: 12px; font-weight: 600;
  color: #1e293b; padding: 0 8px; height: 30px; background: transparent;
}
.qm-grand-box {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg,#0f172a,#1e3a5f);
  border-radius: 10px; padding: 13px 18px; margin-top: 10px;
}
.qm-grand-label { font-size: 12.5px; font-weight: 700; color: #93c5fd; display: flex; align-items: center; gap: 6px; }
.qm-grand-val { font-size: 18px; font-weight: 800; color: #fff; letter-spacing: -.5px; }
 
/* Action footer */
.qm-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0;flex-wrap:wrap;
}
 
/* Reusable buttons */
.qm-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.qm-btn-primary {
  background: linear-gradient(135deg,#2563eb,#3b82f6);
  color: #fff; border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
}
.qm-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.qm-btn-success { background: #fff; color: #16a34a; border-color: #86efac; }
.qm-btn-success:hover { background: #f0fdf4; border-color: #16a34a; }
.qm-btn-info { background: #fff; color: #0284c7; border-color: #bae6fd; }
.qm-btn-info:hover { background: #f0f9ff; border-color: #0284c7; }
.qm-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.qm-btn-ghost:hover { background: #f1f5f9; }
.qm-btn-danger { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.qm-btn-danger:hover { background: #e11d48; border-color: #e11d48; }
 
/* vue-select theming */
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
  transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
</style>
 
 
<template>
 
<!-- ═══════════════════════════════════════════════
     ADD / EDIT QUOTATION — FULLSCREEN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">
 
 
      <!-- ░░ MAIN CONTENT ░░ -->
      <div class="qm-main">
 
        <!-- Topbar -->
        <div class="qm-topbar">
          <div>
            <div class="qm-page-title">{{ id ? 'Edit Quotation' : 'Create New Quotation' }}</div>
            <div class="qm-page-sub">{{ id ? 'Update quotation details below' : 'Fill in the details to generate a new quotation' }}</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="qm-btn qm-btn-ghost" @click="preview">
              <i class="ti ti-eye"></i> Preview
            </button>
            <button type="button" class="qm-close-btn" data-bs-dismiss="modal">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
 
        <!-- Form -->
        <form @submit.prevent="submitQuotation(false)" class="d-flex flex-column" style="flex:1;overflow:hidden;">
 
          <div class="qm-body">
 
            <!-- ── 1. Quote Details ── -->
            <div class="qm-card" id="qm-details">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#eff6ff;"><i class="ti ti-file-description" style="color:#3b82f6;"></i></div>
                <span class="qm-card-title">Quotation Details</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
 
                  <div class="col-md-3">
                    <label class="qm-label">Subject <span class="req">*</span></label>
                    <input type="text" class="qm-input" :class="{'err': errors.subject}" v-model="subject" placeholder="Enter quotation subject..." />
                    <div v-if="errors.subject" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.subject[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Client Type <span class="req">*</span></label>
                    <select class="qm-select" v-model="party_type">
                      <option value="">Choose any</option>
                      <option value="App\Models\Lead" :selected="party_type === `App\\Models\\Lead`">Lead</option>
                      <option value="App\Models\Customer" :selected="party_type === `App\\Models\\Customer`">Customer</option>
                    </select>
                    <div v-if="errors.party_type" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_type[0] }}</div>
                  </div>
 
                  <div class="col-md-3" v-if="party_type === `App\\Models\\Lead` || party_type === `App\\Models\\Customer`">
                    <label class="qm-label">Client <span class="req">*</span></label>
                    <vue-select v-model="selectedParty" :options="parties" :loading="loading" :filterable="false"
                      @search="onSearch" @update:modelValue="onPartySelected" label="name"
                      :placeholder="party_type === `App\\Models\\Lead` ? 'Search lead...' : 'Search customer...'"/>
                    <div v-if="errors.party_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_id[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Sales Person <span class="req">*</span></label>
                    <vue-select :options="users" label="name" placeholder="Select sales person" :reduce="u => u.id" v-model="sales_person_id"/>
                    <div v-if="errors.sales_person_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.sales_person_id[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Date <span class="req">*</span></label>
                    <input type="date" class="qm-input" :class="{'err': errors.quotation_date}" v-model="quotation_date" />
                    <div v-if="errors.quotation_date" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.quotation_date[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Valid Until <span class="req">*</span></label>
                    <input type="date" class="qm-input" :class="{'err': errors.valid_until}" v-model="valid_until" />
                    <div v-if="errors.valid_until" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.valid_until[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Expected Closure</label>
                    <input type="date" class="qm-input" v-model="expected_closure_date" />
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Template</label>
                    <vue-select :options="templates" label="name" v-model="template" placeholder="Choose template"/>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Tax Mode <span class="req">*</span></label>
                    <vue-select :options="tax_modes" v-model="tax_mode"/>
                    <div v-if="errors.tax_mode" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_mode[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Closure %</label>
                    <select class="qm-select" v-model="closure_probability">
                      <option value="10">10%</option>
                      <option value="25">25%</option>
                      <option value="50">50%</option>
                      <option value="75">75%</option>
                      <option value="100">100%</option>
                    </select>
                  </div>
 
                </div>
              </div>
            </div>
 
            <!-- ── 2. Client Info ── -->
            <div class="qm-card" id="qm-client">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#f0fdf4;"><i class="ti ti-user" style="color:#16a34a;"></i></div>
                <span class="qm-card-title">Client Information</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
 
                  <div class="col-lg-4">
                    <label class="qm-label">To (Name)</label>
                    <input type="text" class="qm-input" v-model="to_name" placeholder="Client full name" />
                    <div v-if="errors.to_name" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_name[0] }}</div>
                  </div>
                  <div class="col-lg-4">
                    <label class="qm-label">Email</label>
                    <input type="email" class="qm-input" v-model="to_email" placeholder="client@email.com" />
                    <div v-if="errors.to_email" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Phone</label>
                    <input type="text" class="qm-input" v-model="to_phone" placeholder="+91 00000 00000" />
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Place of Supply</label>
                    <input type="text" class="qm-input" v-model="place_of_supply" />
                  </div>
 
                  <div class="col-12">
                    <label class="qm-label">Address</label>
                    <textarea class="qm-textarea" rows="2" v-model="to_address" placeholder="Full billing address..."></textarea>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">City</label>
                    <input type="text" class="qm-input" v-model="to_city" />
                  </div>
                  <div class="col-md-2">
                    <label class="qm-label">Zip Code</label>
                    <input type="text" class="qm-input" v-model="to_pincode" />
                  </div>
                  <div class="col-md-3">
                    <label class="qm-label">Country</label>
                    <vue-select v-model="to_country" :options="countries" label="name" placeholder="Select country"
                      @update:modelValue="onCountrySelect"/>
                  </div>
                  <div class="col-md-3">
                    <label class="qm-label">State</label>
                    <vue-select v-model="to_state" :options="states" label="name" placeholder="Select state"/>
                  </div>
                  <div class="col-md-2">
                    <label class="qm-label">GST No</label>
                    <input type="text" class="qm-input" v-model="gst_no" placeholder="22AAAAA0000A1Z5" />
                  </div>
 
                </div>
              </div>
            </div>
 
            <!-- ── Invoice-mode Tax ── -->
            <div class="qm-card" v-if="tax_mode == 'Invoice'">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#fffbeb;"><i class="ti ti-percent" style="color:#f59e0b;"></i></div>
                <span class="qm-card-title">Tax Information (Invoice Level)</span>
              </div>
              <div class="qm-card-body">
                <div class="row">
                  <div class="col-md-4">
                    <label class="qm-label">Tax Rate</label>
                    <vue-select :options="taxes" label="name" placeholder="Select tax" v-model="selectedTax"/>
                    <div v-if="errors.tax_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_id[0] }}</div>
                    
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 3. Line Items ── -->
            <div class="qm-card" id="qm-items">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="qm-card-title">Quotation Line Items</span>
                <button type="button" class="qm-add-item-btn ms-auto" @click="addItemRow">
                  <i class="ti ti-plus"></i> Add Item
                </button>
              </div>
              <div class="qm-card-body">
 
                <div v-for="(item, index) in items" :key="index" class="qm-item-card">
                  <div class="qm-item-num">{{ index + 1 }}</div>
                  <input type="hidden" v-model="item.hsn_code" />
 
                  <div class="row g-2 align-items-end">
 
                    <div :class="tax_mode === 'Item' ? 'col-md-2' : 'col-md-4'">
                      <label class="qm-label">Item</label>
                      <vue-select :options="allItems" label="name" v-model="item.item" :get-option-label="item => `${item.name} - ${item.code ?? item.id}`" 
                        @update:modelValue="val => onItemSelected(index, val)" placeholder="Select item"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'item_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'item_id') }}
                      </div>
                    </div>
 
                    <div class="col-md-2" v-if="tax_mode === 'Item'">
                      <label class="qm-label">Tax</label>
                      <vue-select :options="taxes" label="name" v-model="item.selectedTax" placeholder="Tax"
                        @update:modelValue="val => onItemTaxSelected(index, val)"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'tax_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'tax_id') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'Item' ? 'col-md-1' : 'col-md-2'">
                      <label class="qm-label">Unit Cost/ MSP</label>
                      <input type="number" class="qm-input" v-model.number="item.price" @input="updateAmount(index)" placeholder="0.00"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'unit_price')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit_price') }}
                      </div>
                    </div>
 
                    <div class="col-md-2">
                        <label class="qm-label">Unit</label>
                        <vue-select :options="item.availableUnits || standardUnits" label="label" :reduce="u => u" v-model="item.selectedUnit" placeholder="Unit"
                          @update:modelValue="val => onItemUnitSelected(index, val)"
                          :disabled="item.unit === 'Rmt'" />
                        <div class="qm-err-msg" v-if="getItemError(index, 'unit')">
                          <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit') }}
                        </div>
                    </div>                   <!--  -->

                    <template v-if="item.calculation_type === 'dimensional'">
                      <div class="col-md-1">
                        <label class="qm-label">Width (mm)</label>
                        <input type="number" class="qm-input" v-model.number="item.width" @input="updateAmount(index)" placeholder="0" min="0" />
                      </div>
                      <div class="col-md-1">
                        <label class="qm-label">Height (mm)</label>
                        <input type="number" class="qm-input" v-model.number="item.height" @input="updateAmount(index)" placeholder="0" min="0" />
                      </div>
                      <div class="col-md-1">
                        <label class="qm-label">Size</label>
                        <input type="text" class="qm-input" :value="(item.size || 0).toFixed(4)" readonly
                          style="background:#f8fafc;font-weight:600;color:#1e293b;" />
                      </div>
                      <!-- Combined error -->
                      <div class="col-12" v-if="getItemGeneralError(index)">
                        <div class="qm-err-msg" v-for="(err, i) in getItemGeneralError(index)" :key="i">
                          <i class="ti ti-alert-circle"></i>{{ err }}
                        </div>
                      </div>
                    </template>
 
                    <div class="col-md-1">
                      <label class="qm-label">Qty</label>
                      <input type="number" class="qm-input" v-model.number="item.qty" @input="updateAmount(index)" placeholder="1"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'quantity')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'quantity') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'Item' ? 'col-md-1' : 'col-md-2'">
                      <label class="qm-label">Amount</label>
                      <input type="text" class="qm-input" :value="getItemAmountDisplay(item).toFixed(2)" readonly
                        style="background:#f8fafc;font-weight:700;color:#1e293b;" />
                    </div>
 
                    <div class="col-md-1 d-flex align-items-end">
                      <button type="button" class="qm-remove-btn" @click="removeItemRow(index)">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>
 
                    <div class="col-12">
                      <label class="qm-label">Description</label>
                      <ckeditor :ref="`itemEditor${index}`" :editor="editor" v-model="item.description" :config="editorConfig" tag-name="textarea"/>
                    </div>
 
                  </div>
                </div>
 
                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                  No items added yet.
                </div>
 
              </div>
            </div>
 
            <!-- ── 4. Notes & Terms ── -->
            <div class="qm-card" id="qm-notes">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#faf5ff;"><i class="ti ti-notes" style="color:#8b5cf6;"></i></div>
                <span class="qm-card-title">Summary, Terms & Notes</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="qm-label">Summary</label>
                    <ckeditor :editor="editor" v-model="summary" :config="editorConfig"></ckeditor>
                    <div class="qm-err-msg" v-if="errors.summary"><i class="ti ti-alert-circle"></i>{{ errors.summary[0] }}</div>
                  </div>
                  <div class="col-md-4">
                    <label class="qm-label">Terms & Conditions</label>
                    <ckeditor :editor="editor" v-model="settings.terms" :config="editorConfig"></ckeditor>
                    <div class="qm-err-msg" v-if="errors.terms"><i class="ti ti-alert-circle"></i>{{ errors.terms[0] }}</div>
                  </div>
                  <div class="col-md-4">
                    <label class="qm-label">Internal Notes</label>
                    <ckeditor :editor="editor" v-model="notes" :config="editorConfig"></ckeditor>
                    <div class="qm-err-msg" v-if="errors.notes"><i class="ti ti-alert-circle"></i>{{ errors.notes[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 5. Pricing Summary ── -->
            <div class="qm-card" id="qm-pricing">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#f0fdf4;"><i class="ti ti-calculator" style="color:#16a34a;"></i></div>
                <span class="qm-card-title">Pricing Summary</span>
              </div>
              <div class="qm-card-body">
                <div style="max-width:400px;margin-left:auto;">
 
                  <div class="qm-price-row">
                    <span class="qm-price-label">Subtotal</span>
                    <span class="qm-price-val">{{ currency }} {{ totalAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="qm-price-row" v-if="showTaxInfo && taxAmount">
                    <span class="qm-price-label">{{ tax_mode === 'Invoice' ? 'Tax — ' + selectedTax?.name : 'Item Taxes' }}</span>
                    <span class="qm-price-val" style="color:#2563eb;">{{ currency }} {{ taxAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="qm-price-row">
                    <label class="qm-price-label mb-0">Discount</label>
                    <div class="qm-price-input-box">
                      <span class="qm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="qm-price-num-input" v-model.number="discount" />
                    </div>
                  </div>
 
                  <div class="qm-price-row">
                    <label class="qm-price-label mb-0">Transportation</label>
                    <div class="qm-price-input-box">
                      <span class="qm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="qm-price-num-input" v-model.number="transportation_cost" />
                    </div>
                  </div>
 
                  <div class="qm-price-row">
                    <label class="qm-price-label mb-0">Installation</label>
                    <div class="qm-price-input-box">
                      <span class="qm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="qm-price-num-input" v-model.number="installation_cost" />
                    </div>
                  </div>
 
                  <div class="qm-grand-box">
                    <div class="qm-grand-label"><i class="ti ti-check" style="font-size:13px;"></i> Grand Total</div>
                    <span class="qm-grand-val">{{ currency }} {{ grandTotal.toFixed(2) }}</span>
                  </div>
 
                </div>
              </div>
            </div>
 
          </div><!-- /qm-body -->
 
          <!-- Footer -->
          <div class="qm-footer">
            <button type="button" class="qm-btn qm-btn-ghost me-auto" @click="addItemRow">
              <i class="ti ti-plus"></i> Add Item
            </button>
            <button type="button" class="qm-btn qm-btn-success" @click="saveAndDownload">
              <i class="ti ti-download"></i> Save & Download
            </button>
            <button type="button" class="qm-btn qm-btn-info" @click="saveAndSend" v-if="settings?.send_on_email">
              <i class="ti ti-send"></i> Save & Send
            </button>
            <button type="button" class="qm-btn qm-btn-primary" @click="save">
              <i class="ti ti-device-floppy"></i> Save
            </button>
          </div>
 
        </form>
      </div><!-- /qm-main -->
 
    </div>
  </div>
</div>
<!-- /ADD QUOTATION MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     DELETE MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-body" style="padding:32px 24px;text-align:center;">
  <div style="width:60px;height:60px;background:#fff0f3;border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">
    <i class="ti ti-trash-x" style="font-size:26px;color:#f43f5e;"></i>
  </div>
  <h4 style="font-weight:700;color:#0f172a;margin-bottom:8px;">Delete Quotation?</h4>
  <p style="color:#64748b;font-size:13px;margin-bottom:24px;">This action cannot be undone. All selected items will be permanently removed.</p>
  <div class="d-flex justify-content-center gap-3">
    <a href="javascript:void(0);" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="qm-btn qm-btn-danger" @click="deleteQuotation">
      <i class="ti ti-trash"></i> Yes, Delete
    </a>
  </div>
</div>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_action">
  <div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
  <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
    <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">{{ action }}</h4>
    <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
  </div>
  <form @submit.prevent="submitAction">
  <div class="modal-body" style="padding:18px;">
    <div class="mb-3">
      <label class="qm-label">Full Name</label>
      <input type="text" class="qm-input" v-model="acceptance_name" />
      <div v-if="errors.acceptance_name" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.acceptance_name[0] }}</div>
    </div>
    <div class="mb-3">
      <label class="qm-label">Email ID</label>
      <input type="text" class="qm-input" v-model="acceptance_email" />
      <div v-if="errors.acceptance_email" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.acceptance_email[0] }}</div>
    </div>
  </div>
  <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
    <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="qm-btn qm-btn-primary">Submit</button>
  </div>
  </form>
  </div>
  </div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ACTIVITY MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_activity_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Activity Log</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <div class="modal-body" style="padding:18px;">
      <div v-if="activities.length">
        <div v-for="row in activities" :key="row.id"
          style="display:flex;align-items:flex-start;gap:12px;padding:10px 0;border-bottom:1px dashed #f1f5f9;">
          <div style="width:34px;height:34px;background:#fffbeb;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <i class="ti ti-circle-dot" style="color:#f59e0b;font-size:13px;"></i>
          </div>
          <div>
            <p style="margin:0 0 3px;font-size:12.5px;color:#1e293b;font-weight:500;">{{ row.description }}</p>
            <p style="margin:0;font-size:11px;color:#94a3b8;"><i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</p>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;padding:28px;color:#94a3b8;">
        <i class="ti ti-history" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
        No activity recorded yet.
      </div>
    </div>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ASSIGN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_assign_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
  <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">{{ modal_title }}</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<form @submit.prevent="assignQuotation">
  <div class="modal-body" style="padding:18px;">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="qm-label">Assign To</label>
        <select class="qm-select" v-model="user_id">
          <option v-for="row in users" :key="row.id" :value="row.id">{{ row.name }}</option>
        </select>
        <div v-if="errors.user_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.user_id[0] }}</div>
      </div>
      <div class="col-md-6">
        <label class="qm-label">Remark</label>
        <input type="text" class="qm-input" v-model="remark" placeholder="Add a note..." />
        <div v-if="errors.remark" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.remark[0] }}</div>
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button type="submit" class="qm-btn qm-btn-primary w-100">Assign</button>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:14px 18px;flex-direction:column;align-items:stretch;">
    <table class="table table-sm mb-0" style="font-size:12px;" v-if="assignment_history.length">
      <thead style="background:#f8fafc;">
        <tr>
          <th style="font-weight:600;color:#64748b;">#</th>
          <th style="font-weight:600;color:#64748b;">By</th>
          <th style="font-weight:600;color:#64748b;">From</th>
          <th style="font-weight:600;color:#64748b;">To</th>
          <th style="font-weight:600;color:#64748b;">Status</th>
          <th style="font-weight:600;color:#64748b;">Remark</th>
          <th style="font-weight:600;color:#64748b;">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in assignment_history" :key="row.id">
          <td>{{ index + 1 }}</td>
          <td>{{ row.assign_by.name }}</td>
          <td>{{ row.assign_from.name }}</td>
          <td>{{ row.assign_to.name }}</td>
          <td><span style="padding:2px 8px;background:#f0fdf4;color:#16a34a;border-radius:20px;font-size:10px;font-weight:600;">{{ row.status }}</span></td>
          <td>{{ row.remark }}</td>
          <td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else style="text-align:center;padding:14px;color:#94a3b8;font-size:13px;">No assignment history.</div>
  </div>
</form>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     BULK ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="bulk_action_quotation">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Bulk Actions</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="submitBulkAction">
      <div class="modal-body" style="padding:18px;">
        <div style="display:flex;align-items:center;gap:10px;padding:12px 14px;background:#fff0f3;border:1px solid #fecdd3;border-radius:10px;">
          <input type="checkbox" class="form-check-input" name="mass_delete" id="mass_delete" v-model="mass_delete"
            style="width:15px;height:15px;accent-color:#f43f5e;flex-shrink:0;margin-top:0;" />
          <div>
            <label for="mass_delete" style="font-size:12.5px;font-weight:600;color:#991b1b;cursor:pointer;margin:0;">Mass Delete</label>
            <div style="font-size:11px;color:#f87171;">Permanently remove all selected quotations</div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
        <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="qm-btn qm-btn-primary">Confirm</button>
      </div>
    </form>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     MAIL MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_mail_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
      <div>
        <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">{{ modal_title }}</h4>
        <div style="font-size:11px;color:#64748b;margin-top:1px;">Send this quotation via email</div>
      </div>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close" style="filter:invert(1);opacity:.6;"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="sendMail">
     <div class="modal-body" style="padding:20px;">
      <div class="mb-3"><DocumentPlaceholder/></div>
      <div class="mb-3">
        <label class="qm-label">To Email</label>
        <input type="text" class="qm-input" v-model="to_email" placeholder="recipient@email.com" />
        <div class="qm-err-msg" v-if="errors.to_email"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Subject</label>
        <input type="text" class="qm-input" v-model="settings.mail_subject" />
        <div class="qm-err-msg" v-if="errors.mail_subject"><i class="ti ti-alert-circle"></i>{{ errors.mail_subject[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Body</label>
        <ckeditor :editor="editor" v-model="settings.mail_body" :config="editorConfig"></ckeditor>
        <div class="qm-err-msg" v-if="errors.mail_body"><i class="ti ti-alert-circle"></i>{{ errors.mail_body[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Footer</label>
        <ckeditor :editor="editor" v-model="settings.mail_footer" :config="editorConfig"></ckeditor>
        <div class="qm-err-msg" v-if="errors.mail_footer"><i class="ti ti-alert-circle"></i>{{ errors.mail_footer[0] }}</div>
      </div>
     </div>
     <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
      <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
      <button type="submit" class="qm-btn qm-btn-primary"><i class="ti ti-send"></i> Send Email</button>
     </div>
    </form>
  </div>
</div>
</div>
 
</template>
